import EverTrue from 'app';
import BaseRouter from 'base/base-router';
import NotificationDetailsController from 'apps/notifications/controllers/notification-details-controller';

class NotificationRouter extends BaseRouter {
  static initClass() {
    this.prototype.routes = {
      'notification/:id': 'show',
    };
  }

  show(id) {
    this.currentView = <NotificationDetailsController id={Number(id)} />;
    EverTrue.page.mount(this.currentView);
  }
}
NotificationRouter.initClass();

export default NotificationRouter;
